import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { AnatomicalSystemModel } from "../../../models/anatomicalSystem";
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentAnatomicalSystem: AnatomicalSystemModel;
}

interface IState {
	anatomicalSystem: AnatomicalSystemModel,
	validationMessage: string,
	selectedLangId: number
}

class AnatomicalSystemAddEditDialog extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {
			anatomicalSystem: props.currentAnatomicalSystem,
			validationMessage: '',
			selectedLangId: Lang.bg
		};
	}

	handleChange = (key, value) => {
		const anatomicalSystem: AnatomicalSystemModel = { ...this.state.anatomicalSystem };
		anatomicalSystem[key] = value;
		this.setState({ anatomicalSystem: { ...anatomicalSystem } });
	};

	handleChangeContent = (key, value) => {
		const anatomicalSystem: AnatomicalSystemModel = { ...this.state.anatomicalSystem };
		let anatomicalSystemContent = anatomicalSystem.anatomicalSystemContent.find(r => r.langId == this.state.selectedLangId);
		if (anatomicalSystemContent) {
			anatomicalSystemContent[key] = value;
		}
		this.setState({ anatomicalSystem: { ...anatomicalSystem } });
	};

	isValidAddEditForm() {
		let message = '';

		this.setState({
			validationMessage: ''
		});

		if ((!this.state.anatomicalSystem.anatomicalSystemContent
			|| this.state.anatomicalSystem.anatomicalSystemContent.length == 0
			|| !this.state.anatomicalSystem.anatomicalSystemContent[0].anatomicalSystemName
			|| this.state.anatomicalSystem.anatomicalSystemContent[0].anatomicalSystemName.trim() == '')) {
			message += "Please enter 'BG name'.<br />";
		}

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = event => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const anatomicalSystem = this.state.anatomicalSystem;

		this.props.saveClick(anatomicalSystem);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	onLangChange = (langId) => {
		this.setState({ selectedLangId: langId });
	}

	getValueContent = (key) => {
		let anatomicalSystemContent = this.state.anatomicalSystem.anatomicalSystemContent.find(r => r.langId == this.state.selectedLangId)
		if (anatomicalSystemContent) {
			return anatomicalSystemContent[key];
		}
		return '';
	}

	public render() {

		const { anatomicalSystem, selectedLangId } = this.state;

		return (

			<Dialog header="Anatomical System Form" responsive={true} width="70%"
				modal={true}
				visible={this.props.isVisible}
				onHide={this.handleCanselButton}
				footer={
					<div>
						<Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
						<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
					</div>}
			>
				<div style={{ minHeight: '400px', maxHeight: '650px' }}>

					{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
					<div className="p-grid p-fluid">
						<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						<div className="p-col-12 p-md-12">
							<label>Name:</label>
							<InputText
								name="anatomicalSystemName"
								onChange={(e) => this.handleChangeContent('anatomicalSystemName', e.target['value'])}
								value={this.getValueContent('anatomicalSystemName')}
							/>
						</div>
					</div>

				</div>
			</Dialog >
		)
	}
}

export default AnatomicalSystemAddEditDialog;